// extracted by mini-css-extract-plugin
export default {"header":"ScrollTable_header__Ki0b2","scrolled":"ScrollTable_scrolled__p8gXk"};